import { Link } from "react-router-dom";
import { PhoneCall, CalendarCheck } from "lucide-react";
import { site, waLink } from "@/data/site";

export default function MobileActionBar() {
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 lg:hidden border-t border-background-200 bg-background-50/95 backdrop-blur px-3 py-2.5 pb-[max(0.625rem,env(safe-area-inset-bottom))]">
      <div className="flex items-center gap-2">
        <a
          href={`tel:${site.phones[0].number}`}
          className="flex-1 inline-flex items-center justify-center gap-2 text-sm font-semibold whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 text-primary-800 py-3"
        >
          <PhoneCall className="w-4 h-4" /> Call
        </a>
        <a
          href={waLink("Hello AV Clinic, I would like to book an appointment.")}
          target="_blank"
          rel="noreferrer noopener"
          className="flex-1 inline-flex items-center justify-center gap-2 text-sm font-semibold whitespace-nowrap rounded-md bg-secondary-500 text-background-50 py-3"
        >
          <i className="ri-whatsapp-line text-lg" /> WhatsApp
        </a>
        <Link
          to="/appointment"
          className="flex-1 inline-flex items-center justify-center gap-2 text-sm font-semibold whitespace-nowrap rounded-md bg-primary-500 text-background-50 py-3"
        >
          <CalendarCheck className="w-4 h-4" /> Book
        </Link>
      </div>
    </div>
  );
}